// @ts-strict-ignore
import { Component, OnInit } from "@angular/core";
import { ErrorCheck } from "src/app/shared/models/error-check.model";
import { ISO6391Selection } from "src/app/shared/constants/iso-639-1.selection.constants";
import * as C from "../../../../../../shared/constants/globals.constants";
import { EWizDynamicBaseClassComponent } from "src/app/modules/esim/shared/classes/ewiz-dynamic.class";
import * as ProfileModel from "src/app/shared/models/profile.model";

@Component({
  selector: C.EWIZ_LANGUAGE_CONFIGURATION,
  templateUrl: "./language-configuration.component.html",
  standalone: false
})
export class EWizLanguageConfigurationComponent extends EWizDynamicBaseClassComponent implements OnInit, ErrorCheck {
  constructor() {
    super();

    const sortedLanguages = [...this.isoLanguages];

    sortedLanguages.sort((a, b) => {
      return a.label.toLowerCase() > b.label.toLowerCase() ? 1 : -1;
    });

    this.languageSelectionOptions = [{ label: $localize`None`, value: "" }, ...sortedLanguages];
  }

  languageSelectionOptions = [];
  isoLanguages = ISO6391Selection;

  ngOnInit() {
    this.profileValues.languagesVisited = true;
    this.handleFormEvents();

    this.errorCheck(this.profileValues);
  }

  errorCheck(values: ProfileModel.ProfileDto) {
    // Always reset error values to default state prior to executing check
    this.errorFound = false;
    this.errorMessage = "";

    if (values.languages) {
      if (values.languages.language1.value === "") {
        this.errorMessage = $localize`Language entry #1 cannot be set to 'None'`;
        this.errorFound = true;
      } else if (values.languages.language3.value !== "" && values.languages.language2.value === "") {
        this.errorMessage = $localize`Language entry #2 cannot be set to 'None' when entry #3 is specified`;
        this.errorFound = true;
      }
    }

    return this.errorFound;
  }
}
